<template>
    <div class="factories">
        <div class="factories-nav v-center p-2">
            <h2 class="weight-500 xxl v-center heading">
                Factory Settings
            </h2>
        </div>
        <div class="factories-body">
            <div class="factory-details" v-if="activeFactory">
                <div class="factory-header">
                    <h2 class="weight-400 xxl mb-2">{{ activeFactory?.name }}</h2>
                    <div class="location mb-2">
                        <img class="mr-1" width="12px" src="~@/assets/images/icons/location-icon.svg" />
                        {{ activeFactory?.address?.city }}, {{ activeFactory?.address?.state }}
                    </div>
                </div>

                <div class="tabs">
                    <div class="tab" v-for="tab in tabs" :key="tab" :class="{ active: activeTabName === tab }"
                        @click="changeTab(tab)">{{ tab }}</div>
                </div>

                <div class="tab-content">
                    <component :is="activeTabName" :activeFactory="activeFactory"/>
                </div>
            </div>
            <div v-else class="factory-details">
                <div class="tab-content tab-content-empty">
                    <div class="fh fw center" v-if="loading"><loading-circle /></div>
                    <div v-else>No factories available</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/common/modal.vue'
import Storage from '@/components/factorySettings/storage.vue'
import Resources from '@/components/factorySettings/resources.vue'
import Users from '@/components/factorySettings/users.vue'
import Labor from '@/components/factorySettings/labor.vue'
import { mapGetters } from 'vuex'
import Vendors from '@/components/factorySettings/vendorLinkedList.vue'
import LoadingCircle from '@/components/common/loadingCircle.vue'
export default {
  name: 'FACTORIES',
  components: {
    Modal,
    Resources,
    Vendors,
    LoadingCircle,
    Storage,
    Users,
    Labor
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isTenantAdmin', 'isOnProjectLevel', 'collaborator', 'isProjectAdmin', 'currentFactory']),
    activeTabName () {
      const path = this.$route.path.toLowerCase()
      if (path.includes('/storage')) return 'Storage'
      if (path.includes('/vendors')) return 'Vendors'
      if (path.includes('/labor')) return 'Labor'
      if (path.includes('/users')) return 'Users'
      return 'Resources'
    }
  },
  data () {
    return {
      tabs: ['Resources', 'Labor', 'Users', 'Storage', 'Vendors'],
      factories: [],
      activeFactory: null,
      factoryData: {},
      loading: false
    }
  },
  watch: {
    currentFactory (newFactory) {
      this.activeFactory = newFactory
    }
  },
  methods: {
    init () {
      this.activeFactory = this.currentFactory
    },
    changeTab (tabName) {
      const path = tabName.toLowerCase()
      this.$router.push(`/${this.id}/factory-settings/${path}`).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    changeFactory (factory) {
      this.activeFactory = factory
    },
    handleNewFactoryCreated () {
      this.createFactoryModalObject.open = false
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">
.factories {
    height: calc(100vh - 84px);

    &-nav {
        border-bottom: 1px solid #E0E0E0;
        height: 60px;
    }

    &-body {
        display: flex;
        height: calc(100vh - 120px);
    }

    /* LEFT PANEL */
    &-list {
        width: 260px;
        border-right: 1px solid #e0e0e0;
        padding: 16px;
    }

    &-item-list {
        max-height: calc(100vh - 185px);
        overflow-y: auto;
    }

    .list-title {
        font-size: var(--text-s);
        color: #666;
        margin-bottom: 12px;
        text-transform: uppercase;
    }

    .factory-item {
        display: flex;
        gap: 10px;
        padding: 12px;
        border-radius: 6px;
        cursor: pointer;
        margin-bottom: 8px;

        &:hover {
            background: #f5f7fa;
        }

        &.active {
            background: var(--brand-light-color);
        }
        .factory-list {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .location {
            font-size: var(--text-s);
            color: #777;
        }
    }
    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ccc;
        margin-top: 6px;

        &.active {
            background: var(--brand-color);
        }
    }
    .edit {
        height: 16px;
    }

    /* RIGHT PANEL */
    .factory-details {
        flex: 1;
        padding: 24px;
    }

    .tabs {
        display: flex;
        gap: 24px;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 12px;

        .tab {
            padding-bottom: 12px;
            cursor: pointer;
            color: #777;

            &.active {
                color: #000;
                border-bottom: 2px solid #000;
            }
        }
    }

    .tab-content {
        &-empty {
            text-align: center;
            color: #777;
            margin-top: 80px;
        }
    }
}
</style>
